export default __webpack_public_path__ + "static/media/profile.3afa9f6d.png";